export const getThemePlanKey = (theme) => {
  if (!theme) return '';
  const raw = theme.id || theme.theme_id || theme.name || theme.title || '';
  return String(raw)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/** Stable match for updating the correct theme in a list (id, then plan key, then name). */
export const themesMatch = (a, b) => {
  if (!a || !b) return false;
  if (a.id && b.id && String(a.id) === String(b.id)) return true;
  const keyA = getThemePlanKey(a);
  const keyB = getThemePlanKey(b);
  if (keyA && keyB && keyA === keyB) return true;
  const nameA = String(a.name || a.title || '').trim();
  const nameB = String(b.name || b.title || '').trim();
  return !!(nameA && nameB && nameA === nameB);
};

export const getConceptLabelForIntent = (focusSelection, type = 'concept') => {
  const focus = focusSelection || [];
  const isFoodOnly = focus.length === 1 && focus[0] === 'food';
  const isDecorOnly = focus.length === 1 && focus[0] === 'decor';
  
  if (isFoodOnly) {
    if (type === 'concepts') return 'Menu Concepts';
    if (type === 'concept') return 'Menu Concept';
    if (type === 'concept-lower') return 'menu concept';
    if (type === 'concepts-lower') return 'menu concepts';
    if (type === 'concept-lower-plural') return 'menu concepts';
  }
  
  if (isDecorOnly) {
    if (type === 'concepts') return 'Decor Concepts';
    if (type === 'concept') return 'Decor Concept';
    if (type === 'concept-lower') return 'decor concept';
    if (type === 'concepts-lower') return 'decor concepts';
    if (type === 'concept-lower-plural') return 'decor concepts';
  }
  
  if (type === 'concepts') return 'Themes';
  if (type === 'concept') return 'Theme';
  if (type === 'concept-lower') return 'theme';
  if (type === 'concepts-lower') return 'themes';
  if (type === 'concept-lower-plural') return 'themes';
  return 'Theme';
};
